import React from 'react';
import ProductCard from '../../../../ecommerce/globalcomponents/product/ProductCard';
import { Product } from '../../../../Redux/ecommersProduct/types';
import SideCart from '../../../globalcomponents/SideCart/SideCart';

interface ChildCategoreProductsProps {
  products: Product[];
  loading: boolean;
  error: string | null;
}

const ChildCategoreProducts: React.FC<ChildCategoreProductsProps> = ({ products, loading, error }) => {
  if (loading && products.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-yellow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && products.length === 0) {
    return (
      <div className="alert alert-danger m-3" role="alert">
        {error}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-5">
        <h4>No products found matching your criteria.</h4>
        <p className="text-muted">Try adjusting your filters.</p>
      </div>
    );
  }

  return (
    <>
      <div className="display-max">
        <div className="card p-3 mb-4 shadow-sm">
          <img
            className="border-radius-0"
            src="https://t3.ftcdn.net/jpg/07/02/38/18/360_F_702381809_k0Jj93x9uwdtgqjja3mWDfWWj9ryHj7N.jpg"
            alt="Promotion Banner"
            style={{ width: '100%', height: 'auto' }}
          />
        </div>

        <div className="row mx-0">
          {products.slice(0, 12).map((product) => (
            <ProductCard key={product._id} product={product} />
          ))}
        </div>

        {products.length > 12 && (
          <>
            <div className="card p-3 my-4 shadow-sm">
              <img
                className="border-radius-0"
                src="https://t4.ftcdn.net/jpg/06/06/08/59/360_F_606085957_m7lE4bgggPgS8q3IzKcT6bTTIlx5Dy6U.jpg"
                alt="Secondary Banner"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
            <div className="row mx-0">
              {products.slice(12).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="display-mini display-mob pb-5">
        {products.map((product) => (
          <ProductCard key={product._id} product={product} />
        ))}
      </div>
      <SideCart />
    </>
  );
};

export default ChildCategoreProducts;
